export const DEFAULT_PAGINATION_DATA = {
  currentPage: 1,
  itemsPerPage: 10,
  count: 10,
  lastPage: 0,
};

export const DEFAULT_SORT_BY = {
  order: 'ASC',
  column: 'firstName',
};

export const sortByGroupOptions = [
  'firstName',
  'lastName',
  'skills',
  'status',
  'experience',
  'availability',
  'email',
];

export const fieldsAndFriendlyLabels = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'E-mail',
  skills: 'Main Tech Stack',
  status: 'Candidate Status',
  experience: 'Years of Experience',
  availability: 'Availability',
};

export const fieldsAndFriendlyLabelsList = Object.entries(fieldsAndFriendlyLabels);
